export const RECAPTCHA_CALLBACK_NAME = 'recaptchaCallback'
